import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventTypeUpdateChild from "./EventTypeUpdateChild";

import { useLocation } from "react-router-dom";

const EventTypeUpdate = () => {
  const data = useLocation();
  const etRecord = data.state;
  return (
    <MainTemplate>
      <CardBackground>
        <EventTypeUpdateChild etRecord={etRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventTypeUpdate;
